function katakanaToHiragana(value: string): string {
  return value.replace(/[ァ-ヶ]/g, (character) => String.fromCharCode(character.charCodeAt(0) - 0x60));
}

export function normalizeJapaneseSearch(value: string): string {
  return katakanaToHiragana(value.normalize("NFKC").trim().toLocaleLowerCase("ja-JP"))
    .replace(/[\s\u3000]+/g, "");
}

export function normalizeListingUrl(value: string): string {
  const normalized = value.normalize("NFKC").trim();
  try {
    const url = new URL(normalized);
    url.hash = "";
    url.search = "";
    url.pathname = url.pathname.replace(/\/$/, "") || "/";
    return url.toString().replace(/\/$/, "").toLocaleLowerCase("ja-JP");
  } catch {
    return normalized.replace(/\/$/, "").toLocaleLowerCase("ja-JP");
  }
}

export function socialHandleFromListing(value: string): string | null {
  const normalized = value.normalize("NFKC").trim().toLocaleLowerCase("ja-JP");
  if (/^@[a-z0-9_]{1,30}$/u.test(normalized)) return normalized;
  try {
    const url = new URL(normalized);
    const host = url.hostname.replace(/^www\./u, "");
    if (host !== "x.com" && host !== "twitter.com") return null;
    const handle = url.pathname.split("/").filter(Boolean)[0];
    return handle && /^[a-z0-9_]{1,30}$/u.test(handle) ? `@${handle}` : null;
  } catch {
    return null;
  }
}

export function nominationSeedFromListing(value: string): { name: string; officialUrl: string } {
  const normalized = value.normalize("NFKC").trim();
  const handle = socialHandleFromListing(normalized);
  if (handle && normalized.startsWith("@")) {
    return { name: handle, officialUrl: `https://x.com/${handle.slice(1)}` };
  }
  try {
    const url = new URL(normalized);
    const name = handle ?? url.hostname.replace(/^www\./u, "");
    return { name, officialUrl: url.toString() };
  } catch {
    return { name: normalized, officialUrl: "" };
  }
}

export function matchesVerifiedListing(query: string, name: string, officialUrl: string): boolean {
  return normalizeJapaneseSearch(query) === normalizeJapaneseSearch(name)
    || normalizeListingUrl(query) === normalizeListingUrl(officialUrl)
    || Boolean(socialHandleFromListing(query) && socialHandleFromListing(query) === socialHandleFromListing(officialUrl));
}
